var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialInsight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.473662 6.9176C0.212063 6.9176 0 7.12616 0 7.38337V14.2244C0 14.4816 0.212094 14.6901 0.473662 14.6901H3.32743V6.9176H0.473662Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 9.48963C16.0003 8.89837 15.6772 8.37989 15.1955 8.09593C15.3801 7.83389 15.4883 7.51601 15.4883 7.17383C15.4883 6.27855 14.7476 5.55016 13.8371 5.55016H10.3515C10.4583 5.07412 10.6044 4.35979 10.7061 3.612C10.9709 1.66599 10.79 0.586748 10.1368 0.215604C9.72951 -0.0157428 9.29044 -0.0626702 8.9004 0.0833398C8.59908 0.196199 8.19216 0.473673 7.96027 1.15467L7.04415 3.51337C6.57972 4.64126 5.15745 5.82536 4.27539 6.4801V14.8962C5.91016 15.4595 7.61605 15.745 9.35639 15.745H13.1544C14.0648 15.745 14.8056 15.0166 14.8056 14.1213C14.8056 13.8078 14.7147 13.5147 14.5576 13.2663C15.108 13.0027 15.4882 12.4469 15.4882 11.8055C15.4882 11.4633 15.38 11.1454 15.1955 10.8834C15.6772 10.5994 16.0003 10.0809 16.0003 9.48963Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInsight);
export default __webpack_public_path__ + "static/media/social-insight.72bca5e0d3b139f40bcdade19149e2f3.svg";
export { ForwardRef as ReactComponent };